import Prototype from "../common/prototype";

export enum COMPONENT_TYPES {
  COMPOSITE = 'COMPOSITE',
  POSITION = 'POSITION'
}

export default abstract class PortfolioComponent implements Prototype<PortfolioComponent> {
  /**
   * Returns the consolidated notional of the portfolio component.
   */
  abstract notional(): number;

  /**
   * Sets the ideal notional value that this portfolio component should have.
   * @param totalPortfolioNotional 
   */
  abstract setTotalPortfoliolNotional(totalPortfolioNotional: number): void;

  /**
   * Sets the ideal notional value that this portfolio component should have.
   * @param idealNotional 
   */
  abstract setIdealNotional(idealNotional: number): void;

  /**
   * Sets the weight of positions with dynamic weight.
   */
  abstract setDynamicWeight(): void;

  abstract clone(): PortfolioComponent;

  /**
   * Updates a component.
   * @param component The component to be updated.
   */
  abstract updateComponent(component: PortfolioComponent): boolean;

  /** The type of this component. */
  componentType: COMPONENT_TYPES = COMPONENT_TYPES.COMPOSITE;
  /** ID of the portfolio to which this portfolio component belongs to. */
  portfolioId: string = '';
  /** ID of parent portfolio composite. If undefined, this component is the root composite. */
  parentCompositeId?: string;
  /** Relative weight to be given to this portfolio component during rebalancing. */
  weight: number = 0;
  /** The notional value of the entire portfolio to which this component belongs to. */
  totalPortfolioNotional: number = 1;
  /** Ideal notional value that this portfolio component should have. */
  _idealNotional: number = 0;

  /**
   * @returns The ideal notional value that this portfolio component should have.
   */
  idealNotional(): number {
    return this._idealNotional;
  }
  /**
   * @returns The current percentage of the portfolio that this component represents.
   */
  currentPercentage(): number {
    return this.notional() / this.totalPortfolioNotional;
  }
  /**
   * @returns The ideal percentage of the portfolio that this component should represent.
   */
  idealPercentage(): number {
    return this.idealNotional() / this.totalPortfolioNotional;
  }
  /**
   * @returns The deviation that the current notional has compared to the ideal one.
   */
  deviation(): number {
    return this.notional() / this.idealNotional() - 1;
  }
  /**
   * @returns The deviation that the current notional has compared to the ideal one.
   */
  absoluteDeviation(): number {
    return Math.abs(this.notional() / this.idealNotional() - 1);
  }
}